'use client';

import { AchievementDetailSheet } from '@/screens/AchievementsScreen/components/AchievementDetailSheet';
import { useAchievementSheetKey, useCloseAchievementSheet } from '@/stores/achievementSheetStore';

export function GlobalAchievementSheet() {
  const openKey = useAchievementSheetKey();
  const close = useCloseAchievementSheet();
  return <AchievementDetailSheet achievementKey={openKey} onClose={close} viewerIsOwner />;
}
